/**
 * Payout Dashboard Constants
 *
 * Costanti e helper per il modulo payout dashboard.
 */

// Stati del payout (backend flow: pending → invoice_uploaded → paid | invoice_rejected → pending)
export const PAYOUT_STATUS = {
    PENDING: 'pending',
    INVOICE_UPLOADED: 'invoice_uploaded',
    INVOICE_REJECTED: 'invoice_rejected',
    PAID: 'paid'
}

// Labels per gli stati
export const PAYOUT_STATUS_LABELS = {
    [PAYOUT_STATUS.PENDING]: 'Carica fattura',
    [PAYOUT_STATUS.INVOICE_UPLOADED]: 'In validazione',
    [PAYOUT_STATUS.INVOICE_REJECTED]: 'Respinto',
    [PAYOUT_STATUS.PAID]: 'Pagato'
}

// Colori per gli stati (badge variant)
export const PAYOUT_STATUS_VARIANTS = {
    [PAYOUT_STATUS.PENDING]: 'warning',
    [PAYOUT_STATUS.INVOICE_UPLOADED]: 'info',
    [PAYOUT_STATUS.INVOICE_REJECTED]: 'danger',
    [PAYOUT_STATUS.PAID]: 'success'
}

// Stati certificazione azienda
export const CERTIFICATION_STATUS = {
    NOT_CERTIFIED: 'not_certified',
    CREATED: 'created',
    PENDING: 'pending',
    CERTIFIED: 'certified',
    REJECTED: 'rejected'
}

// Scope types
export const SCOPE_TYPES = {
    CONTRACT_MANAGER: 'contract-manager'
}

/**
 * Formatta un importo in EUR
 * @param {string|number} amount - Importo
 * @returns {string} - Importo formattato
 */
export const formatCurrency = (amount, currency = 'EUR') => {
    const num = parseFloat(amount) || 0
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency
    }).format(num)
}

/**
 * Formatta una data
 * @param {string} dateStr - Data ISO
 * @returns {string} - Data formattata
 */
export const formatDate = (dateStr) => {
    if (!dateStr) return '-'
    return new Intl.DateTimeFormat('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(dateStr))
}
